import { useCallback, useMemo, memo } from 'react';
import { Checkbox } from 'foundations-components/transitional/components/Checkbox';
import { useTableDispatch, useTableSelector } from '../../redux/reduxHooks';
import { getSelectedRowIds, setRowsSelected } from '../redux/selectionSlice';
import I18n from 'I18n';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
const SelectAllCheckboxHeader = ({
  rowIds
}) => {
  const selectedRowIds = useTableSelector(getSelectedRowIds);
  const isCurrentPageSelected = useMemo(() => rowIds.length > 0 && rowIds.every(rowId => selectedRowIds.has(rowId)), [rowIds, selectedRowIds]);
  const dispatch = useTableDispatch();
  const handleChange = useCallback(({
    target: {
      checked
    }
  }) => {
    dispatch(setRowsSelected(rowIds.map(rowId => ({
      rowId,
      selected: checked
    }))));
  }, [dispatch, rowIds]);
  return /*#__PURE__*/_jsx("th", {
    "data-test-id": "checkbox-select-all-container",
    "data-selection-column": true,
    children: /*#__PURE__*/_jsx(Flex, {
      alignItems: "center",
      justifyContent: "center",
      flexGrow: 1,
      children: /*#__PURE__*/_jsx(Checkbox, {
        "aria-label": I18n.text('datatable.bulkActions.selectAllCheckboxLabel'),
        "data-test-id": "checkbox-select-all",
        checked: isCurrentPageSelected,
        indeterminate: selectedRowIds.size > 0,
        onChange: handleChange
      })
    })
  });
};
export default /*#__PURE__*/memo(SelectAllCheckboxHeader);